import { GET_REPORT_DATA } from './mutation-types'
import resumidoOperadorHttpService from '../_services/resumidoOperadorHttpService'

export default {
  gerarRelatorioOperadorResumido: async ({ commit }, form) => {
    try {
      const [responseTotal, responseDiaCorrido, responseMediaDia, responseHora, responseMediaHora] = await Promise.all([
        resumidoOperadorHttpService.getRelatorioResumidoOperadorTotal(form),
        resumidoOperadorHttpService.getRelatorioResumidoOperadorDiaCorrido(form),
        resumidoOperadorHttpService.getRelatorioResumidoOperadorMediaDia(form),
        resumidoOperadorHttpService.getRelatorioResumidoOperadorHora(form),
        resumidoOperadorHttpService.getRelatorioResumidoOperadorMediaHora(form),
      ])
      const responseData = []
      for (let i = 0; i < responseTotal.data.length; i++) {
        responseData.push(
          Object.assign(
            {},
            responseTotal.data[i],
            responseDiaCorrido.data[i],
            responseMediaDia.data[i],
            responseMediaDia.data[i],
            responseHora.data[i],
            responseMediaHora.data[i]
          )
        )
      }
      commit(GET_REPORT_DATA, responseData)
    } catch (e) {
      console.log(e)
    }
  },
}
